<template>
  <section :class="getComponentClass(blok, animationClass)">
    <div class="container">
      <div class="clients__content container">
        <div class="row">
          <h3 v-if="blok.title" class="clients__title col-12">
            {{ blok.title }}
          </h3>
        </div>

        <div class="row">
          <div class="col-12 clients__container">
            <div
              v-for="(client, index) in blok.clients"
              :key="client.id"
              :class="getItemClass(client, index)"
            >
              <img
                v-if="client.image && isSvgFile(client.image)"
                :src="client.image"
                :alt="client.name"
                class="clients__image"
              />
              <component
                :is="'a_imageSource' | dashify"
                v-if="client.image && !isSvgFile(client.image)"
                :blok="client"
                :image-url="client.image"
                :alt="client.name"
                modifier-class="clients__image"
              />
              <p v-if="client.text" class="clients__text">
                {{ client.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Clients',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      animationClass: 'clients--animate',
      isAnimationActive: true,
    }
  },
  computed: {
    filteredMobileClients() {
      if (this.blok.clients && this.blok.clients.length > 0) {
        const total = this.blok.clients.length
        const a = []
        for (let i = 0; i < total; i += 1) {
          const client = this.blok.clients[i]
          if (client.showInMobile) {
            a.push(client)
          }
        }
        return a
      }
      return []
    },
    clientGrids() {
      let count = -1
      let index = 0
      const grid = [[]]
      const gridsDesign = [
        {
          amount: 5,
          className: 'one-by-four',
        },
        {
          amount: 5,
          className: 'four-by-one',
        },
        {
          amount: 4,
          className: 'two-by-two clients-grid--border-left',
        },
        {
          amount: 1,
          className: 'one-only',
        },
        {
          amount: 4,
          className: 'two-by-two',
        },
      ]

      if (this.blok.clients) {
        grid[grid.length - 1].className = gridsDesign[0].className

        for (let i = 0; i < this.blok.clients.length; i += 1) {
          count += 1
          if (count === gridsDesign[index].amount) {
            // create a new array
            index += 1
            grid.push([])
            count = 0
            if (index === gridsDesign.length) {
              index = 0
            }
            grid[grid.length - 1].className = gridsDesign[index].className
          }
          grid[grid.length - 1].push(this.blok.clients[i])
        }
      }
      return grid
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
        if (this.isAnimationActive) {
          this.animationClass = 'clients--animate clients--animate-done'
          this.isAnimationActive = false
        }
      }
    },
  },
  methods: {
    isSvgFile(file) {
      return file.split('.').pop() === 'svg'
    },
    getComponentClass(blok, animationClass) {
      const base = 'clients theme-light'
      const shadow = blok.hasShadow ? ' clients--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      const space = blok.space ? `space--${blok.space}` : 'space--small'

      return `${base} ${shadow} ${height} ${space} ${animationClass}`
    },
    getItemClass(client, index) {
      const size = client.text ? 'clients__item--large' : 'clients__item--small'
      const mobile = client.showInMobile ? '' : 'clients--desktop-only'
      const ie = this.getIe11Style(index)
      return `clients__item ${size} ${mobile} ${ie}`
    },
    getIe11Style(index) {
      // This function is only to support IE11. Please remove it once its not required
      let className = ''

      switch (index) {
        case 0:
          className = 'g-column-1 g-row-1'
          break
        case 1:
          className = 'g-column-5 g-row-1'
          break
        case 2:
          className = 'g-column-6 g-row-1'
          break
        case 3:
          className = 'g-column-7 g-row-1'
          break
        case 4:
          className = 'g-column-8 g-row-1'
          break
        case 5:
          className = 'g-column-5 g-row-2'
          break
        case 6:
          className = 'g-column-1 g-row-3'
          break
        case 7:
          className = 'g-column-2 g-row-3'
          break
        case 8:
          className = 'g-column-3 g-row-3'
          break
        case 9:
          className = 'g-column-4 g-row-3'
          break
        case 10:
          className = 'g-column-1 g-row-4'
          break
        case 11:
          className = 'g-column-2 g-row-4'
          break
        case 12:
          className = 'g-column-3 g-row-4'
          break
        case 13:
          className = 'g-column-7 g-row-4'
          break
        case 14:
          className = 'g-column-8 g-row-4'
          break
        case 15:
          className = 'g-column-1 g-row-5'
          break
        case 16:
          className = 'g-column-2 g-row-5'
          break
        case 17:
          className = 'g-column-7 g-row-5'
          break
        case 18:
          className = 'g-column-8 g-row-5'
          break
        default:
      }

      return className
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.clients {
  &--desktop-only {
    display: none;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &--animate {
    .clients__title {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }

    .clients__container {
      opacity: 0;
      transition: opacity 0.7s;
      transition-delay: 0.4s;
    }
  }

  &--animate-done {
    .clients__title {
      transform: translate(0, 0);
      opacity: 1;
    }
    .clients__container {
      opacity: 1;
    }
  }

  &__title {
    @include font-family($font-family-headings-bold, $headings-font-weight);
    @include font-size(36);

    margin-top: 0;
    margin-bottom: spacer(2);
  }

  &__container {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1px;
  }

  &__item {
    outline: $gray-500 solid 1px;
    display: flex;
  }

  &__text {
    @include font-size(12);

    display: none;
    padding: 15px 20px 15px 2px;
    overflow: hidden;
    width: 50%;
    vertical-align: middle;
    margin: 0;
  }

  &__image {
    width: 100%;
    height: auto;
    padding: 20px;
    max-height: 200px;
    align-self: center;
  }
}

@include media-breakpoint-up(md) {
  .clients {
    &--desktop-only {
      display: block;
    }

    &__container {
      -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
      -ms-grid-rows: 1fr 1fr 1fr 1fr 1fr;
      grid-template-columns: repeat(8, 1fr);
    }

    &__item {
      &--large {
        grid-column: auto / span 4;
        grid-row: auto / span 2;
        -ms-grid-column-span: 4;
        -ms-grid-row-span: 2;

        .clients__image {
          width: 50%;
        }

        .clients__text {
          align-self: center;
        }
      }
    }

    &__text {
      display: inline-block;
    }
  }
}

@include media-breakpoint-up(lg) {
  .clients {
    &__text {
      @include font-size(16, rem-v(28));
    }
  }
}

.g-column-1 {
  -ms-grid-column: 1;
}
.g-column-2 {
  -ms-grid-column: 2;
}
.g-column-3 {
  -ms-grid-column: 3;
}
.g-column-4 {
  -ms-grid-column: 4;
}
.g-column-5 {
  -ms-grid-column: 5;
}
.g-column-6 {
  -ms-grid-column: 6;
}
.g-column-7 {
  -ms-grid-column: 7;
}
.g-column-8 {
  -ms-grid-column: 8;
}
.g-row-1 {
  -ms-grid-row: 1;
}
.g-row-2 {
  -ms-grid-row: 2;
}
.g-row-3 {
  -ms-grid-row: 3;
}
.g-row-4 {
  -ms-grid-row: 4;
}
.g-row-5 {
  -ms-grid-row: 5;
}
</style>
